module.exports = __webpack_public_path__ + "static/fonts/element-icons.535877f.woff";


//////////////////
// WEBPACK FOOTER
// ./theme/fonts/element-icons.woff
// module id = oyeL
// module chunks = 18